import type { ExchangeUnit } from '@mntn-dev/domain-types'

import { calculateCostPlusMargin } from './calculate-cost-plus-margin.ts'
import { convertCentsToDollars } from './convert-cents-to-dollars.ts'
import { convertDollarsToCents } from './convert-dollars-to-cents.ts'
import { convertExchangeUnits } from './convert-exchange-units.ts'
import type { CostLike } from './types.ts'

export const sumPrice = (
  costs: CostLike[],
  toCreditUnit?: ExchangeUnit,
  margin?: number
) => {
  const result = costs.reduce<number | undefined>((acc, cost) => {
    const value = cost.cost
    if (value === undefined) {
      return acc
    }

    const withMargin =
      margin !== undefined ? calculateCostPlusMargin(value, margin) : value

    const converted = toCreditUnit
      ? Math.ceil(convertExchangeUnits(withMargin, 'USD', toCreditUnit))
      : convertDollarsToCents(withMargin)

    return acc === undefined ? converted : acc + converted
  }, undefined)
  if (result === undefined) {
    return undefined
  }

  return toCreditUnit ? result : convertCentsToDollars(result)
}
